"use strict";

var _objectWithoutProperties = require("/Users/alecresende/code/visual-sampler/sequencer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectWithoutProperties");

var _excluded = ["children"];

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AuctionInfo = void 0;

var jsx_runtime_1 = require("react/jsx-runtime");

var nft_hooks_1 = require("@zoralabs/nft-hooks");

var react_1 = __importStar(require("react"));

var PricingString_1 = require("../utils/PricingString");

var AddressView_1 = require("../components/AddressView");

var CountdownDisplay_1 = require("../components/CountdownDisplay");

var NFTDataContext_1 = require("../context/NFTDataContext");

var useMediaContext_1 = require("../context/useMediaContext");

var InfoContainer_1 = require("./InfoContainer");

var AuctionInfo = function AuctionInfo(_ref) {
  var _ref$showPerpetual = _ref.showPerpetual,
      showPerpetual = _ref$showPerpetual === void 0 ? true : _ref$showPerpetual,
      className = _ref.className;

  var _a, _b, _c;

  var _react_1$useContext = react_1.useContext(NFTDataContext_1.NFTDataContext),
      nft = _react_1$useContext.nft;

  var _useMediaContext_1$us = useMediaContext_1.useMediaContext(),
      getStyles = _useMediaContext_1$us.getStyles,
      getString = _useMediaContext_1$us.getString;

  var AuctionInfoWrapper = function AuctionInfoWrapper(_ref2) {
    var children = _ref2.children,
        containerArgs = _objectWithoutProperties(_ref2, _excluded);

    return jsx_runtime_1.jsx(InfoContainer_1.InfoContainer, Object.assign({}, containerArgs, {
      className: className
    }, {
      children: children
    }), void 0);
  };

  if (!nft.data) {
    return jsx_runtime_1.jsx(react_1.Fragment, {}, void 0);
  }

  var data = nft.data;

  if (data.pricing.status === nft_hooks_1.AuctionStateInfo.NO_PRICING) {
    return jsx_runtime_1.jsx(react_1.default.Fragment, {}, void 0);
  }

  if (data.pricing.status === nft_hooks_1.AuctionStateInfo.PERPETUAL_ASK && showPerpetual) {
    return jsx_runtime_1.jsxs(react_1.Fragment, {
      children: [data.pricing.perpetual.ask && jsx_runtime_1.jsx(AuctionInfoWrapper, Object.assign({
        titleString: "LIST_PRICE"
      }, {
        children: jsx_runtime_1.jsx(PricingString_1.PricingString, {
          pricing: data.pricing.perpetual.ask.pricing
        }, void 0)
      }), void 0), jsx_runtime_1.jsx(AuctionInfoWrapper, Object.assign({
        titleString: "OPEN_OFFERS"
      }, {
        children: "Be the first one to bid on this piece!"
      }), void 0)]
    }, void 0);
  }

  var reserve = data.pricing.reserve;

  if (data.pricing.reserve && data.pricing.reserve.current.likelyHasEnded && (data.pricing.reserve.status === "Finished" || data.pricing.reserve.status === "Active")) {
    var highestPreviousBid = data.pricing.reserve.currentBid || data.pricing.reserve.previousBids[0];
    return jsx_runtime_1.jsxs(AuctionInfoWrapper, Object.assign({
      className: className,
      titleString: "AUCTION_SOLD_FOR"
    }, {
      children: [jsx_runtime_1.jsx("div", Object.assign({}, getStyles("fullInfoAuctionPricing"), {
        children: jsx_runtime_1.jsx(PricingString_1.PricingString, {
          pricing: highestPreviousBid.pricing
        }, void 0)
      }), void 0), jsx_runtime_1.jsx("div", Object.assign({}, getStyles("fullInfoSpacer", undefined, {
        width: 15
      })), void 0), jsx_runtime_1.jsx("div", Object.assign({}, getStyles("fullLabel"), {
        children: getString("WINNER")
      }), void 0), jsx_runtime_1.jsx(AddressView_1.AddressView, {
        address: highestPreviousBid.bidder.id
      }, void 0)]
    }), void 0);
  }

  if (reserve !== undefined && !reserve.current.likelyHasEnded && reserve.expectedEndTimestamp && reserve.current.highestBid !== undefined) {
    return jsx_runtime_1.jsxs(AuctionInfoWrapper, Object.assign({
      titleString: "AUCTION_ENDS"
    }, {
      children: [jsx_runtime_1.jsx("div", Object.assign({}, getStyles("pricingAmount"), {
        children: jsx_runtime_1.jsx(CountdownDisplay_1.CountdownDisplay, {
          to: reserve.expectedEndTimestamp
        }, void 0)
      }), void 0), jsx_runtime_1.jsx("div", Object.assign({}, getStyles("fullInfoSpacer")), void 0), jsx_runtime_1.jsx("div", Object.assign({}, getStyles("fullLabel"), {
        children: getString("HIGHEST_BID")
      }), void 0), jsx_runtime_1.jsx("div", Object.assign({}, getStyles("fullInfoAuctionPricing"), {
        children: jsx_runtime_1.jsx(PricingString_1.PricingString, {
          pricing: reserve.current.highestBid.pricing
        }, void 0)
      }), void 0), jsx_runtime_1.jsx("div", Object.assign({}, getStyles("fullInfoSpacer")), void 0), jsx_runtime_1.jsx("div", Object.assign({}, getStyles("fullLabel"), {
        children: getString("BIDDER")
      }), void 0), jsx_runtime_1.jsx(AddressView_1.AddressView, {
        address: (_a = reserve.current.highestBid) === null || _a === void 0 ? void 0 : _a.placedBy
      }, void 0)]
    }), void 0);
  }

  if (showPerpetual && data.pricing.auctionType === nft_hooks_1.AuctionType.PERPETUAL && data.pricing.perpetual.highestBid) {
    return jsx_runtime_1.jsx(AuctionInfoWrapper, Object.assign({
      titleString: "HIGHEST_BID"
    }, {
      children: jsx_runtime_1.jsx(PricingString_1.PricingString, {
        pricing: (_b = data.pricing.perpetual.highestBid) === null || _b === void 0 ? void 0 : _b.pricing
      }, void 0)
    }), void 0);
  }

  if (!showPerpetual && data.pricing.auctionType === nft_hooks_1.AuctionType.PERPETUAL) {
    return jsx_runtime_1.jsx(react_1.Fragment, {}, void 0);
  }

  return jsx_runtime_1.jsx(AuctionInfoWrapper, Object.assign({
    titleString: data.pricing.auctionType === nft_hooks_1.AuctionType.PERPETUAL ? "LIST_PRICE" : "RESERVE_PRICE"
  }, {
    children: jsx_runtime_1.jsxs("div", Object.assign({}, getStyles("pricingAmount"), {
      children: [data.pricing.auctionType === nft_hooks_1.AuctionType.PERPETUAL && data.pricing.perpetual.ask && jsx_runtime_1.jsx("div", {
        children: jsx_runtime_1.jsx(PricingString_1.PricingString, {
          pricing: data.pricing.perpetual.ask.pricing
        }, void 0)
      }, void 0), data.pricing.auctionType === nft_hooks_1.AuctionType.RESERVE && ((_c = data.pricing.reserve) === null || _c === void 0 ? void 0 : _c.reservePrice) && jsx_runtime_1.jsxs(jsx_runtime_1.Fragment, {
        children: [jsx_runtime_1.jsx("div", Object.assign({}, getStyles("fullInfoAuctionPricing"), {
          children: jsx_runtime_1.jsx(PricingString_1.PricingString, {
            pricing: data.pricing.reserve.reservePrice
          }, void 0)
        }), void 0), jsx_runtime_1.jsxs("div", {
          children: [jsx_runtime_1.jsx("div", Object.assign({}, getStyles("fullInfoSpacer")), void 0), jsx_runtime_1.jsx("div", Object.assign({}, getStyles("fullLabel"), {
            children: getString("AUCTION_PENDING_DURATION")
          }), void 0), jsx_runtime_1.jsx(CountdownDisplay_1.DurationDisplay, {
            duration: data.pricing.reserve.duration
          }, void 0)]
        }, void 0)]
      }, void 0)]
    }), void 0)
  }), void 0);
};

exports.AuctionInfo = AuctionInfo;